import { useUserSettings } from "@/composables/user/userSettings";
import { AccountType, type User } from "@/services/user/userTypes";

export function isMyNick(nickname: string): boolean {
  try {
    const { userSettings } = useUserSettings();
    const myNickname = userSettings.value?.nickname.toLowerCase();
    return myNickname === nickname.toLowerCase();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e: unknown) {
    return false;
  }
}

export const isOurAccount = (user: User): boolean => {
  return user.type === AccountType.Common;
};

export function assertUserIsLoggedIn(user: User | undefined): asserts user is User {
  if (user === undefined) {
    throw new Error("User is not logged in.");
  }
}
